import React from 'react';
import { Head, Link } from '@inertiajs/react';
import { Box, Typography, Paper, Container, Button, ThemeProvider, CssBaseline } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import theme from '../styles/theme';

interface ErrorProps {
  error: {
    title: string;
    message: string;
    status: number;
  };
}

const Error: React.FC<ErrorProps> = ({ error }) => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Head title={error.title} />
      <Container maxWidth="sm">
        <Box sx={{ mt: 8, mb: 4 }}>
          <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
            <Typography variant="h4" component="h1" gutterBottom color="error">
              {error.title}
            </Typography>
            <Typography variant="body1" color="text.secondary">
              {error.message}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 2, mb: 3 }}>
              Error Code: {error.status}
            </Typography>
            <Button
              component={Link}
              href="/home"
              variant="contained"
              startIcon={<HomeIcon />}
              sx={{ backgroundColor: 'black', mt: 2 }}
            >
              Back to Home
            </Button>
          </Paper>
        </Box>
      </Container>
    </ThemeProvider>
  );
};

export default Error;